// contexts/User/index.jsx
import Cookies from 'js-cookie';
import { createContext, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { LOGIN } from 'store/actions';

export const UserContext = createContext();

// eslint-disable-next-line
const UserProvider = ({ children }) => {
  const dispatch = useDispatch();
  const [isUserLoaded, setIsUserLoaded] = useState(false);

  const loadUser = useCallback(() => {
    let user = localStorage.getItem('user');
    const token = Cookies.get('session');
    if (user && token) {
      let data = JSON.parse(user);
      dispatch({ type: LOGIN, payload: data });
    }
    setIsUserLoaded(true);
  }, [dispatch]);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return <UserContext.Provider value={{ loadUser, isUserLoaded }}> {children} </UserContext.Provider>;
};

export default UserProvider;
